import { render, staticRenderFns } from "./ActivityViewToggle.vue?vue&type=template&id=1efef042"
import script from "./ActivityViewToggle.vue?vue&type=script&lang=js"
export * from "./ActivityViewToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports